import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ShieldAlert } from 'lucide-react';
import { SITE_HOME } from '../../config/siteLinks';

export default function ImpersonationBanner() {
  const { user, logout } = useAuth();

  if (!user?.impersonated_by) return null;

  const returnToSuperadmin = () => {
    // This tab was opened specifically for the impersonated session — the
    // superadmin's own tab was never touched, so "returning" just means
    // closing this one. window.close() only works on script-opened tabs; if
    // it's a no-op (e.g. the tab got reopened later), fall back to logging
    // this tab out instead of leaving it stuck impersonating.
    window.close();
    setTimeout(() => {
      logout();
      window.location.href = SITE_HOME;
    }, 250);
  };

  return (
    <div className="bg-amber-500 text-white text-sm px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
      <span className="flex items-center gap-2">
        <ShieldAlert size={16} className="shrink-0" />
        Viewing as <strong>{user.full_name}</strong>{user.organization_name ? ` (${user.organization_name})` : ''} — actions taken here affect their account.
      </span>
      <button onClick={returnToSuperadmin} className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg font-medium whitespace-nowrap">
        Close & Return to Superadmin
      </button>
    </div>
  );
}
